import { apiClient } from './apiClient';

export const userLanguageService = {
  /**
   * Persists the user's UI language preference server-side.
   * Called on explicit toggle (F-01.5) and on session start for seeding (F-01.3).
   * Throws on network/auth error — callers must handle gracefully (F-01.4).
   */
  setLanguage: (language: string): Promise<void> =>
    apiClient.put<void>('/users/language', { language }),
};
